import styled from 'styled-components';
import ReactDOMServer from 'react-dom/server';
import colors from '../../../../../../../constants/colors';
import ProbSevRiskLines from './ProbSevRiskLines';
import Translator from '../../../../../../components/helpers/Translator';

export default function ProbSevRiskElement(props) {
  const {
    state,
    type,
    size = 16,
  } = props;

  if (type === 'risk') {
    return (
      <RiskBlock
        title={`${ReactDOMServer.renderToString(
          <Translator file="module-legalCompliance" name="module.lc.risk" />
        )} ${
          state !== null
            ? ReactDOMServer.renderToString(
                <Translator
                  file="filter"
                  name={`filter.probability.${state}.m`}
                />
              )
            : ''
        }`}
      >
        <div className="risk-title">
          <Translator file="module-legalCompliance" name="module.lc.risk" />
        </div>
        <ProbSevRiskLines level={state} size={24} />
      </RiskBlock>
    );
  }
  if (type === 'flat-risk') {
    return (
      <span
        title={ReactDOMServer.renderToString(
          <Translator file="module-legalCompliance" name="module.lc.risk" />
        )}
      >
        <b className="pr-1">R</b>
        <ProbSevRiskLines level={state} />
      </span>
    );
  }

  return (
    <span
      title={`${
        type === 'prob'
          ? ReactDOMServer.renderToString(
              <Translator file="filter" name="filter.probability" />
            )
          : ReactDOMServer.renderToString(
              <Translator file="filter" name="filter.severity" />
            )
      } ${
        state !== null
          ? ReactDOMServer.renderToString(
              <Translator file="filter" name={`filter.probability.${state}`} />
            )
          : ''
      }`}
    >
      <b className="pr-1">{type === 'prob' ? 'P' : 'S'}</b>
      <ProbSevRiskLines level={state} />
    </span>
  );
}

const RiskBlock = styled.div`
  border-top: 1px solid ${colors.grey200};
  cursor: default;
  width: 100%;
  height: 80px;
  text-align: center;
  .risk-title {
    text-transform: uppercase;
    font-size: 10px;
    padding-top: 8px;
  }
`;
